module.exports = __webpack_public_path__ + "img/7.6c50f2d9.png";